import { createFileRoute } from "@tanstack/react-router";
import { RouteError } from "../../../shared/components/RouteError";
import { RoutePending } from "../../../shared/components/RoutePending";

/**
 * @purpose Register a new bike quickly during onboarding
 * @primary Bike form
 * @persona paola-admin-belora
 */
export const Route = createFileRoute("/app/c/$customerSlug/bikes/new")({
  errorComponent: ({ error }) => <RouteError error={error} />,
  pendingComponent: RoutePending,
});
